import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-navi';
import { faCog } from '@fortawesome/pro-solid-svg-icons';
import {
  Nav,
  NavItem,
  NavButton,
  NavMenu,
  themeUtils as tu,
  cssMixins,
  Box,
  ExternalLink,
} from '@zen-common/components-base';
import PATHS from '../../paths';
import Logo from '../Logo/Logo';
import DOCS from '../../utils/documentationLinks';
import MainSideNav from './MainSideNav';

const mobileOnlyCss = tu.mq({ display: ['flex', 'none'] });
const hideOnMobileCss = tu.mq({ display: ['none', 'flex'] });

export default function MainNav() {
  return (
    <MainNavContainer>
      <Nav>
        <LeftNavItem>
          <Link href={PATHS.DEFAULT}>
            <Box pr="smd">
              <Logo />
            </Box>
          </Link>
        </LeftNavItem>
        <NavMenu mr="auto" css={hideOnMobileCss}>
          <NavItem>
            <Link href={PATHS.ISSUE} exact={false} activeClassName="active" className="menu-item">
              Issue
            </Link>
          </NavItem>
          <NavItem>
            <Link href={PATHS.REDEEM} exact={false} activeClassName="active" className="menu-item">
              Redeem
            </Link>
          </NavItem>
          <NavItem>
            <Link href={PATHS.CANCEL} exact={false} activeClassName="active" className="menu-item">
              Cancel
            </Link>
          </NavItem>
          <NavItem>
            <Link href={PATHS.VERIFY} exact={false} activeClassName="active" className="menu-item">
              Verify
            </Link>
          </NavItem>
          <NavItem>
            <ExternalLink href={DOCS.DEFAULT} exact={false} className="menu-item">
              DOCS
            </ExternalLink>
          </NavItem>
        </NavMenu>
      </Nav>
      <Nav>
        <NavMenu css={hideOnMobileCss}>
          <RightNavItem>
            <Link href={PATHS.SETTINGS} activeClassName="active">
              <NavButton mx="-11px" icon={faCog} />
            </Link>
          </RightNavItem>
        </NavMenu>
        <NavMenu css={mobileOnlyCss}>
          <SideNavContainerItem>
            <MainSideNav />
          </SideNavContainerItem>
        </NavMenu>
      </Nav>
    </MainNavContainer>
  );
}

const MainNavContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: ${tu.color('bg4')};
`;

const LeftNavItem = styled(NavItem)`
  ${(p) => cssMixins.containerXPadding({ ...p, modifyRight: () => '0' })}
`;
const RightNavItem = styled(NavItem)`
  ${(p) => cssMixins.containerXPadding({ ...p, modifyLeft: (value) => `calc(${value} / 2)` })}
`;

const SideNavContainerItem = styled(RightNavItem)`
  a {
    text-align: left;
  }
`;
